import LangEnum from '../../../lang/LangEnum';
import { BusinessPolicyType } from '../../../services/modules/business-policies/businessPolicies.types';
import {
  BusinessPolicyFactType,
  BusinessPolicyGrain,
  BusinessPolicyMeasureSource,
  BusinessPolicyScopeDimension,
} from '../../../services/modules/business-policies/businessPolicyCondition.types';
import { StatusType } from '../../orders/order.types';
import { UserRole } from '../../users/roles';
import { BusinessPolicyDiscountType } from '../enums/business-policy-discount-type.enum';
import { BusinessPolicyNumberOperator } from '../enums/business-policy-number-operator.enum';
import { BusinessPolicyTypeDefaultValues } from './businessPolicyForm.types';

export enum BusinessPolicyMeasureKey {
  PIECES_ORDER = 'PIECES_ORDER',
  PIECES_PRODUCT_COLOR = 'PIECES_PRODUCT_COLOR',
  PIECES_ORDER_PRODUCT = 'PIECES_ORDER_PRODUCT',
  PIECES_SUGGESTED_ORDER_PRODUCT = 'PIECES_SUGGESTED_ORDER_PRODUCT',
  GROSS_VALUE_SUM_ORDER = 'GROSS_VALUE_SUM_ORDER',
  UNIT_PRICE_SUM_ORDER = 'UNIT_PRICE_SUM_ORDER',
  NET_VALUE_ORDER = 'NET_VALUE_ORDER',
  CREDIT_LIMIT_ORDER = 'CREDIT_LIMIT_ORDER',
  AVAILABLE_BALANCE_ORDER = 'AVAILABLE_BALANCE_ORDER',
  VOUCHER_VALUE_ORDER = 'VOUCHER_VALUE_ORDER',
}

export enum BusinessPolicyMeasureSlot {
  ROOT = 'root',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BusinessPolicyValueInput {
  MONEY = 'money',
  UNIT = 'unit',
}

export enum BusinessPolicyComparativeAvailability {
  NEVER = 'never',
  ALWAYS = 'always',
  VOUCHER_TEMPLATE = 'voucherTemplate',
}

export interface BusinessPolicyMeasureCapability {
  fact: BusinessPolicyFactType;
  grain: BusinessPolicyGrain;
  source: BusinessPolicyMeasureSource;
  valueInput: BusinessPolicyValueInput;
  scopeDimensions: BusinessPolicyScopeDimension[];
  allowOrderHistory: boolean;
  allowPriceCompositions: boolean;
  supportsZeroComparisonUi: boolean;
  supportsUnmatchedHandlingUi: boolean;
  labelLangEnum: LangEnum;
}

export interface BusinessPolicyRewardCapability {
  multiple: boolean;
}

export interface BusinessPolicyTypeRequirements {
  roles: boolean;
  paymentMethodIds: boolean;
  rewardValue: boolean;
  integrationCodeWithTotvs: boolean;
}

export interface BusinessPolicyTypeDefaults {
  values: BusinessPolicyTypeDefaultValues;
  rootMeasureKey: BusinessPolicyMeasureKey;
  rootNumberOperator: BusinessPolicyNumberOperator;
}

export interface BusinessPolicyTypeCapability {
  measures: Record<BusinessPolicyMeasureSlot, BusinessPolicyMeasureKey[]>;
  comparativeAvailability: BusinessPolicyComparativeAvailability;
  scopeDimensions: BusinessPolicyScopeDimension[];
  allowOrderHistory: boolean;
  allowPriceCompositions: boolean;
  discountTypes: BusinessPolicyDiscountType[];
  rewards: BusinessPolicyRewardCapability;
  requirements: BusinessPolicyTypeRequirements;
  roleOptions: UserRole[];
  activateOnOrderStatusOptions: StatusType[];
  requiresVoucherTemplate: boolean;
  defaults: BusinessPolicyTypeDefaults;
}

export interface IsMeasureAllowedParams {
  type: BusinessPolicyType;
  measureKey: BusinessPolicyMeasureKey;
  slot: BusinessPolicyMeasureSlot;
}

export interface IsComparativeAllowedParams {
  type: BusinessPolicyType;
  isVoucherTemplate?: boolean;
}

export interface IsComparativeAcceptedParams extends IsComparativeAllowedParams {
  discountType?: BusinessPolicyDiscountType | null;
}
